import GraphQL from './ConsultaGraphQL';

import url from '../../../../../apiService/ApiUrl.js';

// JavaScript Document
function handleError(err, This){
	console.log(`Request failed: ${err}`);
	This.setState({
		loading: false,
		deleteReporteSEPMensaje: {
			response: 'failure',
			mensaje: `Hubo un error, el error fué: ${err}, intenta de nuevo`
		}
	})
}

const updateProyecto = (This, data) => {
	const options = {
		method: 'post',
		headers: {
			"Content-type": "application/json"
		},
		body: JSON.stringify(GraphQL(data)),
		credentials: 'include'
	}

	//llamada de datos con Fetch
	fetch(url, options)
	.then(res => res.json())
	.then( (res) => {

		This.props.dispatch({
			type: 'CHANGE_STATE_REPORTE_SEP',
			payload: {
				nuevosReportes: data.informesSEP,
				proyectoId: res.data.deleteInformeSEP.id
			}
		})

		This.setState({
			loading: false,
			deleteReporteSEPMensaje: {
				response: 'success',
				mensaje: res.data.deleteInformeSEP.mensaje
			}
		})
		return res

	})
	.then(() => {
		setTimeout( () => {
			This.setState({
				deleteReporteSEPMensaje: null
			}) 
		}, 3000);
	})
	.catch(err => handleError(err, This))
	.then(() => {
		setTimeout( () => {
			This.setState({
				deleteReporteSEPMensaje: null
			}) 
		}, 3000);
	});

	//termina fetch
}

export default updateProyecto;
